'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../styles");
var Data = require("../data");
var Difficulty_1 = require("./Setup/Difficulty");
var FlagsEnabled_1 = require("./Setup/FlagsEnabled");
var NumberLives_1 = require("./Setup/NumberLives");
var GameSeed_1 = require("./Setup/GameSeed");
var StylishButton_1 = require("./StylishButton");
var Utils = require("../utils/SetupUtils");
var Setup = /** @class */ (function (_super) {
    __extends(Setup, _super);
    function Setup(props) {
        var _this = _super.call(this, props) || this;
        _this.seeds = [];
        _this.state = {
            difficulty: 0,
            flagsEnabled: true,
            numLives: 1,
            gameSeed: Utils.generateSeed(),
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleStart = _this.handleStart.bind(_this);
        _this.handleGenerateSeed = _this.handleGenerateSeed.bind(_this);
        return _this;
    }
    /**
     * Handles changes to the configuration html elements.
     */
    Setup.prototype.handleChange = function (event) {
        switch (event.target.id) {
            case 'difficulty':
                if (event.target.selectedIndex === undefined) {
                    return;
                }
                var selectedIndex = event.target.selectedIndex;
                if (Data.difficulties[selectedIndex] === undefined) {
                    return;
                }
                this.setState({ difficulty: selectedIndex });
                break;
            case 'flags-enabled':
                if (event.target.checked === undefined) {
                    return;
                }
                this.setState({
                    flagsEnabled: event.target.checked,
                });
                break;
            case 'number-lives':
                if (event.target.type !== 'number' &&
                    event.target.type !== 'text') {
                    return;
                }
                var numLives = parseInt(event.target.value, 10);
                if (numLives < 1) {
                    return;
                }
                this.setState({ numLives: numLives });
                break;
            case 'game-seed':
                if (event.target.type !== 'text') {
                    return;
                }
                this.setState({ gameSeed: event.target.value });
                break;
            default:
                return;
        }
    };
    /**
     * Handles a click on the "Start Game" button.
     */
    Setup.prototype.handleStart = function () {
        this.props.onStart({
            numMines: Data.difficulties[this.state.difficulty].mines,
            dimensions: {
                rows: Data.difficulties[this.state.difficulty].rows,
                cols: Data.difficulties[this.state.difficulty].cols
            },
            flagsEnabled: this.state.flagsEnabled,
            numLives: this.state.numLives,
            gameSeed: this.state.gameSeed,
        });
    };
    /**
     * Handles a call for a new game seed.
     */
    Setup.prototype.handleGenerateSeed = function () {
        this.setState({ gameSeed: Utils.generateSeed() });
    };
    Setup.prototype.render = function () {
        return (React.createElement("div", { id: 'setup', style: Styles.setup },
            React.createElement(Difficulty_1.Difficulty, { value: this.state.difficulty, onChange: this.handleChange }),
            React.createElement(FlagsEnabled_1.FlagsEnabled, { checked: this.state.flagsEnabled, onChange: this.handleChange }),
            React.createElement(NumberLives_1.NumberLives, { value: this.state.numLives, onChange: this.handleChange }),
            React.createElement(GameSeed_1.GameSeed, { value: this.state.gameSeed, onChange: this.handleChange, onGenerate: this.handleGenerateSeed }),
            React.createElement(StylishButton_1.StylishButton, { id: 'start-button', styles: Styles.startGameButton, text: 'Start Game', events: { onClick: this.handleStart } })));
    };
    return Setup;
}(React.Component));
exports.Setup = Setup;
//# sourceMappingURL=Setup.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Setup.js
// module id = 28
// module chunks = 0